import styled from 'styled-components';

export const ChannelSelectorContainer = styled.div`
    max-width: 500px;
`;